module.exports = __webpack_public_path__ + "static/media/barcode.9dda6841.svg";